import React from 'react'
import { CreateCushionChargePolicyFlowProvider } from './context/CreateCushionChargePolicyFlowProvider'
import { CreateCushionChargePolicyFlowMain } from './components/CreateCushionChargePolicyFlowMain'

export const CreateCushionChargePolicyFlow = () => {
  return (
    <CreateCushionChargePolicyFlowProvider>
      <CreateCushionChargePolicyFlowMain />
    </CreateCushionChargePolicyFlowProvider>
  )
}
